module.exports = __webpack_public_path__ + "img/MiniEstrategias.1d250fd9.png";